import PropTypes from 'prop-types';
import React, {useMemo} from 'react';
import amex from 'payment-icons/min/flat/amex.svg';
import defaultCard from 'payment-icons/min/flat/default.svg';
import diners from 'payment-icons/min/flat/diners.svg';
import discover from 'payment-icons/min/flat/discover.svg';
import jcb from 'payment-icons/min/flat/jcb.svg';
import mastercard from 'payment-icons/min/flat/mastercard.svg';
import unionpay from 'payment-icons/min/flat/unionpay.svg';
import visa from 'payment-icons/min/flat/visa.svg';
import {Box, Button, Flex, Img, Text, chakra} from '@chakra-ui/react';
import {Link as GatsbyLink} from 'gatsby';

export default function PaymentMethod({card, children}) {
  const imageSrc = useMemo(() => {
    switch (card.brand) {
      case 'Visa':
        return visa;
      case 'MasterCard':
        return mastercard;
      case 'American Express':
        return amex;
      case 'Diners Club':
        return diners;
      case 'Discover':
        return discover;
      case 'JCB':
        return jcb;
      case 'UnionPay':
        return unionpay;
      default:
        return defaultCard;
    }
  }, [card]);

  return (
    <Flex align="center" lineHeight="normal">
      <Img src={imageSrc} h="1.25em" mr="0.5em" rounded="sm" />
      <div>
        <chakra.span fontFamily="mono">xxxx xxxx xxxx {card.last4}</chakra.span>
        {children}
      </div>
    </Flex>
  );
}

PaymentMethod.propTypes = {
  children: PropTypes.node,
  card: PropTypes.object.isRequired
};

export function PaymentMethodControl({paymentMethod, ...props}) {
  return (
    <Box {...props}>
      <Text mb="1" fontSize="sm">
        Payment method:
      </Text>
      <Flex>
        {paymentMethod ? (
          <PaymentMethod card={paymentMethod} />
        ) : (
          <Text>No payment method</Text>
        )}
        <Button
          ml="auto"
          size="xs"
          rounded="full"
          as={GatsbyLink}
          to="/account#billing"
        >
          {paymentMethod ? 'Change' : 'Add card'}
        </Button>
      </Flex>
    </Box>
  );
}

PaymentMethodControl.propTypes = {
  paymentMethod: PropTypes.object
};
